import i18n from '../../__mocks__/i18nextMock'

/**
 * Can be used to get a translation without using the 'useTranslation' hook.
 * This enables use of translations in contexts where hooks are not available.
 * @param {String} key - The translation key, e.g. 'accountContact.addAContact'
 * @param {Object} options - The variables used in the translation, e.g. { contactType: 'director' }
 * @returns {String} The translated string
 */
export const getTranslation = (key: string, options?: {}) => {
  return i18n.t(key, options).valueOf()
}
